import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { recordAsternReceipt } from '../../api/incentiveClaimApi';
import { handlePriceWithRM } from '../../utils/priceUtils';

const FONT = { fontFamily: "'Poppins', sans-serif" };

export default function IncentiveAsternModal({ open, onClose, row, onSaved }) {
    const [amount, setAmount] = useState('');
    const [receivedOn, setReceivedOn] = useState(null);
    const [remark, setRemark] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (open && row) {
            setAmount(row.asternAmount ?? '');
            setReceivedOn(row.asternReceivedOn ? dayjs(row.asternReceivedOn) : null);
            setRemark(row.asternRemark ?? '');
        }
    }, [open, row]);

    if (!row) return null;

    const handleSave = async () => {
        if (!receivedOn) { alert('Please pick the date Astern paid.'); return; }
        setSaving(true);
        try {
            await recordAsternReceipt({
                claimId: row.claimId,
                amount: parseFloat(amount) || 0,
                receivedOn: receivedOn.format('YYYY-MM-DD'),
                remark,
            });
            onSaved?.();
            onClose();
        } catch (e) {
            alert('Failed to record: ' + (e.response?.data || e.message));
        } finally { setSaving(false); }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '14px' } }}>
            <DialogTitle sx={{ ...FONT, fontWeight: 700, fontSize: '1rem' }}>Record Astern Receipt</DialogTitle>
            <DialogContent>
                <Typography sx={{ ...FONT, fontSize: '0.8rem', color: '#64748B', mb: 2 }}>
                    {row.salesId > 0
                        ? `Sale #${row.salesId} · ${row.campaignName} · ${row.customerName ?? ''}`
                        : `${row.campaignName} · ${row.contribution ?? 0} cases · earned ${handlePriceWithRM(row.amount ?? 0)}`}
                </Typography>
                <Box sx={{ display: 'grid', gap: 2 }}>
                    <TextField label="Amount received (RM)" type="number" size="small" value={amount}
                        onChange={e => setAmount(e.target.value)} InputProps={{ sx: FONT }} InputLabelProps={{ sx: FONT }} />
                    <DatePicker label="Received on" format="DD/MM/YYYY" value={receivedOn}
                        onChange={setReceivedOn}
                        slotProps={{ textField: { size: 'small', fullWidth: true, InputProps: { sx: FONT }, InputLabelProps: { sx: FONT } } }} />
                    <TextField label="Remark (which sale / note)" size="small" multiline rows={2} value={remark}
                        onChange={e => setRemark(e.target.value)} InputProps={{ sx: FONT }} InputLabelProps={{ sx: FONT }} />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} sx={{ ...FONT, textTransform: 'none', color: '#64748B' }}>Cancel</Button>
                <Button onClick={handleSave} variant="contained" disabled={saving}
                    sx={{ ...FONT, textTransform: 'none', fontWeight: 600, borderRadius: '8px', background: 'linear-gradient(135deg, #1A8CFF, #0F62CC)', boxShadow: 'none' }}>
                    {saving ? 'Saving...' : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
